import React, { ReactElement } from 'react';

interface ContentProps {}

function Content({}: ContentProps): ReactElement {
  return <div>Register Email Page</div>;
}

export { Content };
